import { layout, media } from '@prisjakt/ui-base';
import { Badge } from '@prisjakt/ui/badge';
import styled from 'styled-components';

export const StyledBadge = styled(Badge)`
  ${media.largeUp`
    margin-right: ${layout.measurements.spacing025};
  `}
`;
